module.exports = __webpack_public_path__ + "static/img/delivery_note.54649c03.svg";